export default __webpack_public_path__ + "static/Floorplan_1AR_v1-2ec42b3e95a012370e262d5d7f57d3e0.svg";